<template lang="pug">
    d2-container
        .mod-user
        el-form(:inline='true', :model='dataForm', size='mini')
          el-row()
            el-col(:md='7' :sm="12")
              el-form-item(label="用户名:")
                  el-input.inputWidth(v-model='dataForm.userName', placeholder='用户名', clearable='')
            el-col(:md='7' :sm="12")
              el-form-item(label="主办方:" )
                el-select.inputWidth(v-model="dataForm.orgId" placeholder="请选择" filterable clearable)
                  el-option(v-for="(item,index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
        el-row(style="padding-bottom:15px;" ,:span="24")
          el-col(:md='23')
              el-button(v-if="isAuth('sys:user:save')", type='primary', @click='addOrUpdateHandle()') 新增
              el-button(v-if="isAuth('sys:user:delete')", type='danger', @click='deleteHandle()', :disabled='dataListSelections.length <= 0') 删除
          el-col(:span='1' style='float:right;')
              el-button(@click='getDataList()',icon='el-icon-search',type='primary',style='float:right;') 查询
        el-table(:data='dataList', border='', v-loading='dataListLoading', @selection-change='selectionChangeHandle', style='width: 100%;')
            el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='username', header-align='center', align='center', label='用户名')
            el-table-column(prop='orgName', header-align='center', align='center', label='主办方')
            el-table-column(prop='dataAuthority', header-align='center', align='center', label='数据权限设置')
              template(slot-scope='scope')
                    span(v-if='scope.row.dataAuthority == 1') 全部
                    span(v-if='scope.row.dataAuthority == 2') 仅本主办方
            el-table-column(prop='roleName', header-align='center', align='center', label='角色')
            el-table-column(prop='mobile', header-align='center', align='center', label='联系电话')
            el-table-column(prop='email', header-align='center', align='center', label='邮箱地址')
            el-table-column(prop='detail', header-align='center', align='center', label='用户介绍')
              template(slot-scope='scope')
                span(:title="scope.row.detail") {{scope.row.detail | ellipsis}}

            el-table-column(prop='createTime', header-align='center', align='center', width='180', label='创建时间')
            el-table-column(prop='',header-align='center',align='center',label='操作',width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" v-if="isAuth('sys:user:update')"  @click="addOrUpdateHandle(scope.row.userId)") 修改
                                el-menu-item(index="1-2" v-if="isAuth('sys:user:delete')"  @click="deleteHandle(scope.row.userId)") 删除
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        // 弹窗, 新增 / 修改
        add-or-update(v-if='addOrUpdateVisible', ref='addOrUpdate', @refreshdatalist='getDataList')
</template>

<script>
import AddOrUpdate from './user-add-or-update'
export default {
  name: 'sys-user',
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 20) {
        return value.slice(0, 20) + '...'
      }
      return value
    }
  },
  data () {
    return {
      isCollapse: true,
      dataForm: {
        userName: '',
        orgId: ''
      },
      sysOrgList: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    this.getDataList()
    this.initOrg()
  },
  methods: {
      //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/sys/user/list'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'username': this.dataForm.userName,
          'orgId': this.dataForm.orgId
        })
      }).then((data) => {
        console.log('data', data)
        if (data && data.code === 0) {
          this.dataList = data.page.records
          this.totalPage = data.page.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    initOrg () {
        this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle (id) {
      var userIds = id ? [id] : this.dataListSelections.map(item => {
        return item.userId
      })
      this.$confirm(`是否删除用户?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/sys/user/delete'),
          method: 'post',
          data: this.$http.adornData(userIds, false)
        }).then((data) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else { this.$message.error(data.msg) }
        })
      }).catch(() => {})
    }
  }
}
</script>
<style>
/* 操作三点 菜单样式 */
@import'../../css/opr3dot.css';

.inputWidth{
  width: 210px;
}

</style>
